import { FC, useState } from 'react'
import { Checkbox, ListItemText, Select, MenuItem, OutlinedInput, SelectProps, Typography } from '@mui/material'

/* Components */
import { SortCheckboxIcon, SelectDropdownIcon } from 'ui/components/svg'
import theme from 'theme'
import { CategoryMenuProps, IntegrationsFormControl, Wrapper } from './styles/sortButtonSelect.styles'

interface Props extends SelectProps {
  options: string[]
  value: any
  handleChange: any
  label?: string
}

const SortButtonSelect: FC<Props> = ({ options, handleChange, value, label, ...rest }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <Wrapper className="dropdown-container">
      {label && <Typography className="label-text">{label}</Typography>}
      <IntegrationsFormControl isopen={anchorEl ? 'true' : 'false'}>
        <Select
          labelId="integrations-select-label"
          id="integrations-select"
          displayEmpty
          MenuProps={{
            ...CategoryMenuProps,
            PaperProps: {
              ...CategoryMenuProps.PaperProps,
              sx: {
                ...CategoryMenuProps.PaperProps.sx,
                display: anchorEl ? 'block' : 'none'
              }
            },
            anchorEl,
            open: Boolean(anchorEl),
            onClose: () => setAnchorEl(null)
          }}
          sx={{
            '& .MuiSelect-icon': { transform: anchorEl ? 'rotate(180deg)' : 'rotate(0deg)' }
          }}
          IconComponent={(props) => (
            <SelectDropdownIcon {...props} className={`${props.className} ${anchorEl ? 'is-open' : ''}`} />
          )}
          renderValue={(selected) => {
            if (Array.isArray(selected)) {
              const pruned = selected.filter((s: string) => s !== '')
              if (pruned.length === 0) {
                return 'None'
              }
              if (pruned.length === 1) {
                return pruned[0]
              }

              return `${pruned.length} selected`
            }

            return selected
          }}
          inputProps={{ 'aria-label': 'Without label' }}
          {...rest}
          value={value}
          onChange={handleChange}
          input={<OutlinedInput onMouseDown={handleClick} />}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option} onClick={() => setAnchorEl(null)}>
              <Checkbox
                checked={value.indexOf(option) > -1}
                icon={<SortCheckboxIcon />}
                checkedIcon={
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                }
              />
              <ListItemText
                primary={option}
                sx={{
                  '.MuiTypography-root': {
                    color: value.indexOf(option) > -1 ? `${theme.colors.menuItemText} !important` : ''
                  }
                }}
              />
            </MenuItem>
          ))}
        </Select>
      </IntegrationsFormControl>
    </Wrapper>
  )
}

export default SortButtonSelect
